import React, { ReactElement } from 'react';

import { Button, ButtonColor, ButtonVariant } from '@videoblocks/storywind';

const FeatureList = (props): ReactElement => (
  <section
    className={`w-full ${
      props.darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'
    }`}
  >
    <div
      className="
        px-2.5 md:px-28 lg:px-16 lg:mx-auto
        py-13 md:py-16 lg:py-8 
        max-w-7xl w-full 
        flex flex-col flex-nowrap 
        items-center justify-center"
    >
      <h2 className="font-bold text-3xl md:text-5xl mb-6 font-serif">
        {props.heading}
      </h2>
      <ul className="justify-content mb-4 md:mb-6 grid grid-cols-2 lg:grid-cols-4">
        {props.featureBullets?.length > 0 &&
          props.featureBullets.map((bullet) => (
            <li
              key={bullet.heading}
              className={`
                flex
                flex-col
                justify-items-start
                max-w-1/4
                md:px-2
                mx-2.5
                md:mx-4.5`}
            >
              <div>
                <img
                  src={bullet.icon}
                  alt={bullet.iconAlt}
                  height="32"
                  width="32"
                />
              </div>
              <div className="flex flex-col md:justify-items-left justify-content mb-4 md:mb-6">
                <h3 className="flex-nowrap">{bullet.heading}</h3>
                <div className="text-base md:text-xl">{bullet.text}</div>
              </div>
            </li>
          ))}
      </ul>
      <div className="text-center flex justify-center md:justify-center">
        {props.showCallToAction && (
          <div className="flex justify-center text-center">
            <Button
              className={`${
                props.callToActionHref ? 'text-black no-underline' : ''
              } mb-8`}
              href={props.callToActionHref}
              variant={props.callToActionType}
              color={props.callToActionColor}
            >
              {props.callToActionText}
            </Button>
          </div>
        )}
      </div>
    </div>
  </section>
);

FeatureList.defaultProps = {
  darkMode: false,
  imagesFirst: false,
  content: '',
  showCallToAction: false,
  callToActionType: ButtonVariant.Contained,
  callToActionHref: '#',
  callToActionText: '',
  callToActionColor: ButtonColor.Primary,
  heading: '',
  featureBullets: [],
};

export default FeatureList;
